import React, {useState, useEffect} from 'react';
import Clessidra from '../Pagine/Clessidra';
import IconaMenu from './IconaMenu'
import stile from './stile.module.css';

import { haPersonalizzazione } from '../funzioni.js';

const STATO_RICERCA_DATI = 0;
const STATO_RICERCA_DATI_CORRETTA = 2;

function Home(props) {
    var iconaEventi = require('./eventi2.png');
    var iconaQrcode = require('./qrcodegs.png');
    var iconaPrenotazioni = require('./prenotazioni2.png');
    var iconaScadenze = require('./scadenze.png');
    var iconaNews = require('./news2.png');
    var iconaAllenamenti = require('./allenamenti.png');
    var iconaMovimenti = require('./euro2.png');
    var iconaAbbonamenti = require('./abbonamenti2.png');
    var iconaImpostazioni = require('./impostazioni.png');
    var iconaCambioSocieta = require('./cambiosocieta.png');
    var iconaSafeguarding = require('./safeguarding.png');
    const [statoPagina,setStatoPagina]=useState(STATO_RICERCA_DATI);

    var notificheColore = "#F0F0FF";
    var notificheSfondo = "#0000B0";
    var notificheTesto = "Verifica Stato Notifiche...";
    var notificheTestoAlert = props.statoVerificaNotifiche+","+props.token;
    if (props.statoVerificaNotifiche=="ok") {
        notificheColore = "#00F000";
        notificheSfondo = "#009000";
        notificheTesto = "Notifiche Attivate";
        notificheTestoAlert = "";
    }
    if (!props.token || props.token=="") {
        notificheColore = "#F00000";
        notificheSfondo = "#900000";
        notificheTesto = "Notifiche Disattivate";
        notificheTestoAlert = "Le notifiche non sono attive. Hai un browser non compatibile o non hai consentito le notifiche quando lo ha richiesto. I browser compatibili sono Safari (di serie su iPhone e iPad) o Chrome (da usare su Android). L'app deve essere lanciata da icona. Se hai fatto tutto e non funziona, prova a eliminare l'icona, torna su app.gestionesportiva.it e reinstalla la app come viene indicato";
    }

    const emailIdentita = props.identitaSelezionabili?.email ?? null;
    const elencoSocieta = Array.isArray(props.identitaSelezionabili?.elenco)
      ? props.identitaSelezionabili.elenco
    : [];

    const mostraPagamenti =
    props.identitaSelezionata.nome_database !== "EMA48" &&
    props.identitaSelezionata.nome_database !== "EMA108";

    const mostraCambioSocieta = elencoSocieta.length > 0;

    const vociMenu = [
        {
            testo: "Eventi",
            immagine: iconaEventi,
            pagina: props.PAGINECLIENTI.eventi,
            evidenzia: props.identitaSelezionata.flag_nuovi_eventi > 0 && props.identitaSelezionata.flag_staff == 0,
            badge: props.identitaSelezionata.flag_nuovi_eventi > 0 ? props.identitaSelezionata.flag_nuovi_eventi : 0
        },
        {
            testo: "QR Code",
            immagine: iconaQrcode,
            pagina: props.PAGINECLIENTI.qrcode
        },
        {
            testo: "Allenamenti",
            immagine: iconaAllenamenti,
            pagina: props.PAGINECLIENTI.allenamenti
        },
        {
            testo: "Prenotazioni",
            immagine: iconaPrenotazioni,
            pagina: props.PAGINECLIENTI.prenotazioniMenu
        },
        {
            testo: "Scadenze",
            immagine: iconaScadenze,
            pagina: props.PAGINECLIENTI.scadenze,
            evidenzia: props.identitaSelezionata.flag_scadenze > 0,
            badge: props.identitaSelezionata.flag_scadenze > 0 ? props.identitaSelezionata.flag_scadenze : 0
        },
        {
            testo: "News",
            immagine: iconaNews,
            pagina: props.PAGINECLIENTI.news,
            evidenzia: props.identitaSelezionata.flag_news > 0,
            badge: props.identitaSelezionata.flag_news > 0 ? props.identitaSelezionata.flag_news : 0
        },
        mostraPagamenti && {
            testo: "Pagamenti",
            immagine: iconaMovimenti,
            pagina: props.PAGINECLIENTI.movimenti
        },
        {
            testo: "Abbonamenti",
            immagine: iconaAbbonamenti,
            pagina: props.PAGINECLIENTI.abbonamenti
        },
        {
            testo: "Impostazioni",
            immagine: iconaImpostazioni,
            pagina: props.PAGINECLIENTI.impostazioni
        },
        haPersonalizzazione(props.identitaSelezionata, "safeguarding_attivo") && {
            testo: props.identitaSelezionata.resp_safeguarding === 1 ? "Safeguarding": "Segnala abusi",
            immagine: iconaSafeguarding,
            pagina: props.PAGINECLIENTI.safeguardingSegnalazioni,
            evidenzia: props.identitaSelezionata.flag_safeguarding_messaggi == 1,
        },
        mostraCambioSocieta && {
            testo: "Cambia Società",
            immagine: iconaCambioSocieta,
            pagina: props.PAGINECLIENTI.cambioSocieta
        }
    ].filter(Boolean);

    useEffect(() => {
        setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
        /*
        setStatoPagina(STATO_RICERCA_DATI);
        scaricaDati();        */
    },[]);

    /*

    useEffect(() => {
        if (props.statoVerificaNotifiche!="ok" && props.token && props.token!="") {
            // quando lo stato delle notifiche passa a "verifica in corso", riscarico i dati anche se l'avevo già fatto nella useEffect(()=>{...},[])
            // perché su alcuni telefoni ci mette del tempo a passare da "Notifiche Disattivate" a "verifica in corso"
            scaricaDati();        
        }

        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then((registrations) => {
              if (registrations.length > 0) {
                console.log("Service Worker registrati:", registrations);
                registrations.forEach((registration, index) => {
                  console.log(`Service Worker ${index + 1}:`, registration);
                  console.log("Scope:", registration.scope);
                  console.log("Stato attuale:", registration.active ? "Attivo" : "Non attivo");
                });
              } else {
                console.log("Nessun Service Worker registrato.");
              }
            }).catch((error) => {
              console.error("Errore durante il recupero delle registrazioni dei Service Worker:", error);
            });
        }        
    },[props.statoVerificaNotifiche, props.token]);

    function scaricaDati() {
        var richiediVerificaNotifiche = 0;
        if (props.statoVerificaNotifiche=="") richiediVerificaNotifiche = 1;
        
        var fcm_token="";
        if (props.token) fcm_token=props.token;

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({op:"homeAppClienti", fcm_token:fcm_token, richiediVerificaNotifiche:richiediVerificaNotifiche, emak:props.emak, sessionId: props.sessionId})
        };
    
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {          
                if(valoreDiRitorno.risultatoOperazione===1){
                    setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                } else {
                    console.log("Sessione scaduta, torna a login");
                    props.setPagina(props.PAGINECLIENTI.login);
                }
          },
          (error) => {console.log("Errore fetch"); props.setPagina(props.PAGINECLIENTI.login);}
        );        
    }

    */

    if (statoPagina === STATO_RICERCA_DATI) {
        return (<Clessidra loading={true} />)
    }

    const ora = new Date().getHours();
    console.log(props.identitaSelezionata)

    return (
        <div className={stile.homeBackground}>
            <div style={{
                textAlign: "center",
                color: "#808080",
                fontSize: 15,
                fontWeight: 500,
                marginTop: 10,
                marginBottom: 6,
                fontFamily: "Inter, Roboto, Nunito, sans-serif"
            }}>
                {props.identitaSelezionata.idpersona &&
                    `${ora < 17 ? "Buongiorno," : "Buonasera,"} ${props.identitaSelezionata.nome}`                    
                }                
            </div>           

            <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(150px, 190px))",
                gap: "14px 24px",
                justifyContent: "center",
                padding: "8px 14px 22px 14px",
                boxSizing: "border-box",
                width: "100%"
            }}>
                {vociMenu.map((voce) => (
                    <IconaMenu
                        key={voce.testo}
                        home
                        callback={() => props.callback(voce.pagina)}
                        immagine={voce.immagine}
                        testo={voce.testo}
                        evidenzia={voce.evidenzia}
                        badge={voce.badge}
                    />
                ))}
            </div>

            <div 
                style={{
                    marginTop:"auto",
                    marginBottom:"auto",
                    marginLeft:"auto",
                    marginRight:"auto",
                    display:"flex",
                    width:"60%",
                    justifyContent:"center", 
                    fontVariant: "small-caps",
                }}
            >
            </div>
        </div>
    )
}

export default Home;
